import { render, staticRenderFns } from "./cDocumentsWithParts.vue?vue&type=template&id=753146d9&scoped=true"
import script from "./cDocumentsWithParts.vue?vue&type=script&lang=js"
export * from "./cDocumentsWithParts.vue?vue&type=script&lang=js"
import style0 from "./cDocumentsWithParts.vue?vue&type=style&index=0&id=753146d9&prod&scoped=true&lang=css"
import style1 from "./cDocumentsWithParts.vue?vue&type=style&index=1&id=753146d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753146d9",
  null
  
)

export default component.exports